import { useContext } from 'react';

import DataContext from '../store/dataContext';

const useApiPostOrderError = () => {
  const { apiPostOrderError } = useContext(DataContext);

  const hasCreditCardError = () => apiPostOrderError?.errorCode?.id === 'NF_CHECKOUT_0008';

  const hasBillingError = () =>
    apiPostOrderError?.errorCode?.id === 'NF_CHECKOUT_0009' || apiPostOrderError?.errorCode?.id === 'NF_CHECKOUT_0110';

  const hasPhoneError = () =>
    apiPostOrderError?.errorCode?.id === 'NF_CHECKOUT_0008' ||
    apiPostOrderError?.errorCode?.id === 'NF_CHECKOUT_0009' ||
    apiPostOrderError?.errorCode?.id === 'NF_CHECKOUT_0110';

  const getApiPostOrderErrorCode = () => apiPostOrderError?.errorCode?.id;

  return { hasCreditCardError, hasBillingError, hasPhoneError, getApiPostOrderErrorCode };
};

export default useApiPostOrderError;
